// extracted by mini-css-extract-plugin
export default {"actions":"audit-table_actions__tgcNp"};